import React, { useState, useEffect,useRef } from 'react';
import StyledFlickity from "./styledFlickity";
import api from './setAxios';
import config, { formaturl } from '../config/staticData';
import { Link, useNavigate } from 'react-router-dom';
import {HELMETSEO} from '../components/seopage';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const HeaderIndex = () => {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [menu, setMenu] = useState([]);
    const [hashtag, setHashtag] = useState([]);
    const [banner, setBanner] = useState(null);
    const [clicked, setClicked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isOverlayVisible, setOverlayVisible] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);

    const handleClick = (event) => {
        event.stopPropagation();
        setClicked(!clicked);
    };

    const handleMouseEnter = () => {
        setOverlayVisible(true);
    };

    const handleMouseLeave = () => {
        setOverlayVisible(false);
    };

    const flickityHashtagOptions = {
        initialIndex: 2,
        prevNextButtons: false,
        pageDots: false,
        watchCSS: true
    };

    const flickityAdvOptions = {
        initialIndex: 2,
        cellAlign: 'right',
        watchCSS: true
    };

    useEffect(() => {
        const load = async () => {
            try {
                const [result, bannerResult, hashtagResult] = await Promise.all([
                    api.get("/blog/GetLastBlog/5"),
                    api.get("/files/GetFiles/12"),
                    api.get("/blogStructure/GetStructure/hashtag")
                ]);

                setBlogs(result.data);
                setBanner(bannerResult.data[0]);
                setHashtag(hashtagResult.data);
            } catch (error) {
                console.error("Error fetching data:", error);
                setBanner(null);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    const flickityAdvContent = blogs.map((item, index) => {
        const blogId = item.id;
        const urlSlug = formaturl(item.title);
        return (
            <Link key={index} to={`${process.env.REACT_APP_BASE_PATH}/${blogId}/${urlSlug}`} state={{ blogId }} className={`item item${index}`}>
                <img key={index} src={`${config.blogPath}${item.blogPic}`} alt={item.title} />
                <div className='adv-title' >
                    {item.title}
                </div>
            </Link>
        );
    });

    const flickityHashtagContent = hashtag.map((item, index) => (
        <Link key={index} to={`${process.env.REACT_APP_BASE_PATH}/hashtag/${item.id}/${formaturl(item.title)}`}>
            <span className={`itemhashtag itemhashtag${index}`} key={index}>#{item.title}</span>
        </Link>
    ));

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)) {
            setMenu(false);
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, []);

    return (
        <>
            <HELMETSEO
                title={"مقالات"}
                description={"مقالات تورنگ"}
                keyword={"فروشگاه آنلاین تورنگ، مقالات، مقالات تورنگ"}
            />


            <div className="homepage-header">
                <nav id="nav" className="nav">
                    <div className="nav-center">
                        <div className="nav-header">
                            <button id="nav-btn" className="nav-btn" onClick={handleClick}>
                                <i className="fa fa-bars"></i>
                            </button>
                            <Link to='https://www.toorangco.com' target='_blank' className="logo_container">
                                <img className="img-logo-mobile" src="images/logo-mobile.webp" alt="Logo Mobile" />
                                <img className="img-logo-desktop" src="images/logo.webp" alt="Logo Desktop" />
                            </Link>
                            <Link to={`${process.env.REACT_APP_BASE_PATH}/search`} className="mobile-search">
                                <i className="fa fa-search" aria-hidden="true"></i>
                            </Link>
                        </div>

                        <div className="nav-body">
                            <span className="hashtag-title">هشتگ های داغ</span>
                            {loading ? (
                                <Skeleton count={1} height={30} />
                            ) : (
                                <StyledFlickity flickityOptions={flickityHashtagOptions} flickityStyle={'carousel-navbar'} flickityContent={flickityHashtagContent} />
                            )}
                            <Link to={`${process.env.REACT_APP_BASE_PATH}/search`} className="desktop-search">
                                <i className="fa fa-search" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </nav>
                <div className='header-main'>
                    {isOverlayVisible && <div className="overlay-dark"></div>}
                    <aside id="sidebar" className={clicked ? "sidebar show-sidebar" : "sidebar"}  >
                        <button className="close-btn" ref={buttonRef} onClick={handleClick}>
                            <i className="fas fa-times"></i>
                        </button>
                        <div ref={menuRef} className="sidebar-menu" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <ul className="sidebar-links">
                                <li className="sidebar-logo-mobile">
                                    <img src="images/logo.png" alt="Logo" />
                                </li>
                                <li onClick={() => navigate(`${process.env.REACT_APP_BASE_PATH}/new`)}>
                                    جدیدترین مطالب
                                </li>
                                <li onClick={() => window.open("https://www.toorangco.com/home/infopages/aboutus", '_blank', 'noopener noreferrer')}>
                                    درباره ما
                                </li>
                                <li onClick={() => window.open("https://www.toorangco.com/home/contactus", '_blank', 'noopener noreferrer')}>
                                    تماس با ما
                                </li>
                                <li className="sidebar-footer" onClick={() => window.open('https://www.toorangco.com/', '_blank', 'noopener noreferrer')}>
                                    <i className="fa-solid fa-basket-shopping"></i>
                                    فروشگاه آنلاین تورنگ
                                </li>
                            </ul>
                        </div>
                        <div className="sidebar-img">
                            <a target="_blank" href="https://www.toorangco.com/">
                                <img src='Images/left_banner.png' alt="Left Banner" />
                            </a>
                        </div>
                    </aside>
                    <section className="adv">
                        {banner ? (
                            banner.refUrl ? (
                                <a href={banner.refUrl} target="_blank" rel="noopener noreferrer">
                                    <img className="adv-img" src={`${config.bannerPath}${banner.fileName}`} alt="Banner" />
                                </a>
                            ) : (
                                <img className="adv-img" src={`${config.bannerPath}${banner.fileName}`} alt="Banner" />
                            )
                        ) : (
                            <Skeleton height={200} />
                        )}
                        {loading ? (
                            <Skeleton height={300} />
                        ) : (
                            <StyledFlickity flickityOptions={flickityAdvOptions} flickityStyle={'carousel'} flickityContent={flickityAdvContent} />
                        )}
                    </section>
                </div>
            </div>
        </>
    );
};

export default HeaderIndex;
